import { render, staticRenderFns } from "./LaboratoryCategoryFilter.vue?vue&type=template&id=43294a2c"
import script from "./LaboratoryCategoryFilter.vue?vue&type=script&lang=js"
export * from "./LaboratoryCategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports